/**
 *
 * EnvAuthenticatorStepThree Component
 *
 */

import {
  Button,
  TextField,
  stylize,
} from "@envestnet/envreact-component-library";
import classnames from "classnames";
import React from "react";
import { EnvAuthenticatorStatusEnum } from "scenes/EnvAuthenticator/enums";
import withIntl from "utils/withIntl";
import messages from "./messages";
import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;

  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below
  secretCode: string;
  status: EnvAuthenticatorStatusEnum;
}

export interface EnvAuthenticatorStepThreeProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;

  onCancel: Function;
  onNext: Function;
}

const defaultProps: DefaultProps = {
  secretCode: "",
  status: EnvAuthenticatorStatusEnum.INITIAL,
};

type Props = InjectedProps & EnvAuthenticatorStepThreeProps;

const EnvAuthenticatorStepThree = (props: Props) => {
  const {
    classes,
    style,
    className,
    formatMessage,
    innerRef,
    onCancel,
    secretCode,
    onNext,
    status,
  } = props;

  const [key, setKey] = React.useState(secretCode);

  return (
    <div
      ref={innerRef}
      className={classnames(className, classes.container)}
      style={style}
    >
      <div
        className={classnames(
          classes.descriptionClass,
          "header-text-font-family"
        )}
      >
        {formatMessage(messages.header)}
      </div>
      <div
        className={classnames(
          classes.informationClass,
          "header-text-font-family"
        )}
      >
        {formatMessage(messages.info)}
      </div>
      <div data-testid="okta-verify-step-two-code-input">
        <TextField
          label={formatMessage(messages.keyTextField)}
          text={key.match(/.{1,4}/g)?.join("  ")}
          onChangeText={(text) => setKey(text)}
          textStyle={{ fontFamily: "Red Hat Text" }}
          className={classnames(
            classes.textfieldClass,
            "header-font-family",
            "no-border-radius"
          )}
          disabled
          textFieldStyle={classes.disabledTextFieldClass}
          aria-label="secret code textfield"
        />
      </div>
      <div>
        <Button
          buttonStyle="primary"
          buttonSize="regular"
          className={classnames(
            classes.verifyButtonClass,
            "no-border-radius",
            "header-text-font-family"
          )}
          name={formatMessage(messages.nextButtonLabel)}
          onClick={() => onNext()}
          loading={status === EnvAuthenticatorStatusEnum.PROCESSING}
          aria-label="next button"
        />
      </div>
      <div>
        <Button
          buttonStyle="link"
          buttonSize="regular"
          className={classnames(
            classes.linkButtonClass,
            "header-text-font-family"
          )}
          name={formatMessage(messages.cancelButtonLabel)}
          onClick={() => onCancel()}
          aria-label="cancel button"
        />
      </div>
    </div>
  );
};

EnvAuthenticatorStepThree.defaultProps = defaultProps;

export default withIntl(
  stylize<Props, DefaultProps>(styles)(EnvAuthenticatorStepThree)
);
